import * as graphql from '@treams/treams-network';

import { useViewerRoles } from './useViewerRoles';
import { useWorkspace } from './useWorkspace';

export function useFeatureDetails(id: graphql.FeatureName): {
	available?: boolean;
	loading: boolean;
} {
	const viewerRoles = useViewerRoles();

	const { data } = graphql.useFeaturesQuery({
		variables: {
			id: useWorkspace().id,
		},
	});

	const enabledFeatures = data?.workspace.features
		.filter(
			(feature) =>
				feature.status === graphql.WorkspaceFeatureStatus.Enabled ||
				(viewerRoles.isWorkspaceSuperuser &&
					feature.status === graphql.WorkspaceFeatureStatus.Superuser),
		)
		.map(({ feature }) => feature.id);

	if (!enabledFeatures) {
		return { loading: true };
	}

	const available = enabledFeatures.includes(id) ?? false;

	return { available, loading: false };
}
